import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/opd-doctors/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/doctors/$slug", params: { slug: params.slug }, replace: true, statusCode: 301 });
  },
});
